import React from "react"
import Image from "gatsby-plugin-sanity-image"

export const ImageModule = ({ image }) => {
  return image && <Image {...image} className="w-full" />
}
